import _ from "underscore";

const DOMEventsListenerMixin = {
    /**
     * Starts listening to DOM events.
     * @param $el DOM element of the component.
     * @param handlers Object containing functions-handlers as properties.
     */
    _initDOMEventsListener: function($el, handlers, className, findEmittersFunction)
    {
        this._domEventHandlers = handlers;

        // Link DOM element and event listener component
        $el[0].domEventsListener = this;
        // Add class for DOM search later
        $el.addClass(className);

        // Try to find existing emitters in DOM and subscribe to them (works in case the emitter was initialized before listener)
        _.each(findEmittersFunction($el), function(emitterEl)
        {
            emitterEl.domEventsEmitter._addDOMEventsListener(this);
        }, this);
    },

    /**
     * Calls event handler of specified name (if found).
     * @param eventName Event name.
     */
    _handleDOMEvent: function(eventName)
    {
        if (this._domEventHandlers && this._domEventHandlers[eventName])
            this._domEventHandlers[eventName]();
    }
};

const DOMEventsEmitterMixin = {
    /**
     * Fires event with specified name.
     * @param eventName Event name.
     */
    triggerDOMEvent: function(eventName)
    {
        _.each(this._domEventsListeners, function(listener)
        {
            listener._handleDOMEvent(eventName)
        });
    },

    /**
     * Initializes DOM events emitter.
     * @param $el DOM element of the component.
     */
    _initDOMEventsEmitter: function($el, className, findListenersFunction)
    {
        // Link DOM element and event emitter component
        $el[0].domEventsEmitter = this;
        // Add class for DOM search later
        $el.addClass(className);

        // Try to find event listeners in DOM subscribe them to self (works in case any listeners were initialized before the emitter)
        _.each(findListenersFunction($el), function(listenerEl)
        {
            this._addDOMEventsListener(listenerEl.domEventsListener);
        }, this);
    },

    /**
     * Subscribes specified listener to the emitter.
     * @param listener Listener object.
     */
    _addDOMEventsListener: function(listener)
    {
        if (!this._domEventsListeners)
            this._domEventsListeners = [];

        // Make sure listeners can't be subscribed many times
        if (!_.contains(this._domEventsListeners, listener))
            this._domEventsListeners.push(listener);
    }
};

/**
 * Gives component an ability to listen to ancestor events - custom-defined events fired from ancestor DOM element.
 */
export const AncestorEventsListenerMixin = _.extend({
    initAncestorEventsListener: function($el, handlers)
    {
        this._initDOMEventsListener($el, handlers, "ancestorEventsListener", function($el) { return $el.parents(".ancestorEventsEmitter"); });
    }
}, DOMEventsListenerMixin);

/**
 * Gives component an ability to emit ancestor event, which components related to descendant DOM elements may listen to.
 */
export const AncestorEventsEmitterMixin = _.extend({
    initAncestorEventsEmitter: function($el)
    {
        this._initDOMEventsEmitter($el, "ancestorEventsEmitter", function($el) { return $el.find(".ancestorEventsListener"); });
    }
}, DOMEventsEmitterMixin);

/**
 * Gives component an ability to listen to descendant events - custom-defined events fired from descendant DOM element.
 */
export const DescendantEventsListenerMixin = _.extend({
    initDescendantEventsListener: function($el, handlers)
    {
        this._initDOMEventsListener($el, handlers, "descendantEventsListener", function($el) { return $el.find(".descendantEventsEmitter"); });
    }
}, DOMEventsListenerMixin);

/**
 * Gives component an ability to emit descendant event, which components related to parent DOM may listen to.
 */
export const DescendantEventsEmitterMixin = _.extend({
    initDescendantEventsEmitter: function($el)
    {
        this._initDOMEventsEmitter($el, "descendantEventsEmitter", function($el) { return $el.parents(".descendantEventsListener"); });
    }
}, DOMEventsEmitterMixin);


// WEBPACK FOOTER //
// ./web/js/AncestorEventsMixins.js